import styled from 'styled-components';

import Variables from 'styles/Variables';

type BadgeProps = { error?: boolean };

export const Wrapper = styled.div`
	max-width: 520px;
	margin: 3rem auto;
	padding: 0 1rem;
`;

export const Content = styled.div`
	text-align: center;
`;

export const IconBadge = styled.div`
	width: 72px;
	height: 72px;
	margin: 0 auto 1.5rem;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${Variables.colors.light};
	background-color: ${({ error }: BadgeProps) => (error ? Variables.colors.danger : Variables.colors.main)};
`;

export const Message = styled.p`
	font-size: 1.125rem;
	font-weight: 600;
	margin-bottom: 2rem;
	color: ${Variables.colors.dark};
`;
